import React from 'react';
import * as PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Alert, Typography} from '@mui/material';
import {compose} from "redux";
import {getUrl, PWAUrls} from "../config/urls";

const AlertUnlockComponent = ({
                            guidebooks,
                            routeType,
                            product,
                            t, i18n}) => {
    return (<Alert severity="info">
        {product?.priceLabel && <Typography gutterBottom>{t("AlertUnlockComponent." + routeType + ".buy_product")}</Typography>}
        {Array.isArray(guidebooks) && <>
            <Typography>{t("AlertUnlockComponent." + routeType + ".guidebook", {count: guidebooks.length})}</Typography>
            <ul className='mt-2 mx-0'>
                {guidebooks.map((guidebook, index) => <li key={guidebook.id}><Link to={getUrl(PWAUrls.TOPO, {lng: i18n.language, slug: guidebook.slug})}>{guidebook.label}</Link></li>)}
            </ul>
        </>}
    </Alert>);
};

AlertUnlockComponent.defaultProps = {
    guidebooks: PropTypes.array,
    price: PropTypes.string
};

export default compose(
    withTranslation()
)(AlertUnlockComponent);